import React, { useEffect, useRef, useState } from 'react';
import { PrinterOutlined } from '@ant-design/icons';
import { QRCodeSVG } from 'qrcode.react';
import { toast } from 'react-toastify';
import { useReactToPrint } from 'react-to-print';
import { TaiSan } from '../../models/taisan/TaiSan';
import { layDsTaiSanInQR, layDsTaiSanInQRToanBo } from '../../services/taisan';
import { Modal } from 'react-bootstrap';
import { Button } from 'antd';
import { TimKiemTaiSanRequest } from '../../models/taisan/TaiSan';

interface InTemQRTaiSanProps {
    show: boolean;
    idsTaiSan: number[];
    inToanBo?: boolean;
    filter?: TimKiemTaiSanRequest;
    onClose: () => void;
}

const InTemQRTaiSan: React.FC<InTemQRTaiSanProps> = ({ show, idsTaiSan, inToanBo, filter, onClose }) => {
    const [dsTaiSan, setDsTaiSan] = useState<TaiSan[]>([]);
    const [isLoading, setIsLoading] = useState(false);
    const componentRef = useRef<any>();

    const handlePrint = useReactToPrint({
        content: () => componentRef.current,
        documentTitle: `Tem_QR_TaiSan_${new Date().getTime()}`,
    });

    const loadData = async () => {
        try {
            setIsLoading(true);
            let result;
            if (inToanBo && filter) {
                result = await layDsTaiSanInQRToanBo(filter);
            } else {
                result = await layDsTaiSanInQR(idsTaiSan);
            }
            setDsTaiSan(result);
        } catch (error: any) {
            toast.error('Lỗi khi tải dữ liệu: ' + error.message);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        if (show && (idsTaiSan.length > 0 || inToanBo)) {
            loadData();
        }
    }, [show, idsTaiSan, inToanBo, filter]);

    return (
        <Modal show={show} onHide={onClose} size="xl">
            <Modal.Header closeButton>
                <Modal.Title>In tem mã QR tài sản</Modal.Title>
            </Modal.Header>
            <Modal.Body style={{ maxHeight: '70vh', overflow: 'auto' }}>
                <div ref={componentRef} style={{ padding: '20px' }}>
                    <style>
                        {`
                            @media print {
                                @page {
                                    size: A4;
                                    margin: 10mm;
                                }
                                .qr-item {
                                    page-break-inside: avoid;
                                    break-inside: avoid;
                                }
                            }
                            .qr-container {
                                display: grid;
                                grid-template-columns: repeat(3, 1fr);
                                gap: 15px;
                            }
                            .qr-item {
                                border: 1px solid #ddd;
                                padding: 15px;
                                text-align: center;
                                background: white;
                            }
                            .qr-item img {
                                max-width: 100%;
                                height: auto;
                            }
                            .qr-info {
                                margin-top: 10px;
                                font-size: 12px;
                            }
                            .qr-info strong {
                                display: block;
                                margin-bottom: 5px;
                            }
                        `}
                    </style>
                    
                    <div className="qr-container">
                        {dsTaiSan.map((taiSan) => (
                            <div key={taiSan.id} className="qr-item">
                                                <QRCodeSVG
                                                    value={taiSan.maQR || ''}
                                                    size={200}
                                                    level="M"
                                                />
                                <div className="qr-info">
                                    <strong>{taiSan.maPhu ? `${taiSan.maChinh}/${taiSan.maPhu}` : taiSan.maChinh}</strong>
                                    <div>{taiSan.tenTaiSan}</div>
                                    <div>{taiSan.tenDonVi}</div>
                                    {taiSan.viTriSuDung && <div>Vị trí: {taiSan.viTriSuDung}</div>}
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button onClick={onClose}>
                    Đóng
                </Button>
                <Button type="primary" onClick={handlePrint} disabled={isLoading}>
                    <PrinterOutlined /> In tem QR
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default InTemQRTaiSan;
